import React, { useContext, useState, useEffect } from 'react'
import './index.sass'
import { DarkModeContext } from '../../global/Theme'

import {useHistory} from 'react-router-dom'


export default function SettingsTabBar({ img, text, img2, text2, onUpdate, title }) {
    const { isDark } = useContext(DarkModeContext);
    const [isActive, setIsActive] = useState(0);

    const [bodyWidth, setBodyWidth] = useState(document.body.clientWidth);
    const [bodyHeight, setBodyHeight] = useState(document.body.clientHeight);

    const handleClick = (e, setIsActive) => {
        onUpdate(e, setIsActive);
    }

    const history = useHistory();
    const goBackSimonHaha = () => {
        history.goBack()
    }

    const updateView = (v) => {
        if (v <= 580) {
            document.getElementById('desktopNav').style.display = "none";
            console.log("hum chupa rahe hai settingsTabBar.js")
            document.getElementById('mainWrapper').classList.add('zero-bottom-padding')
        }

        else{
            document.getElementById('desktopNav').style.display = "flex";
            document.getElementById('mainWrapper').classList.remove('zero-bottom-padding')
        }

    }

    useEffect(() => {
        updateView(window.innerWidth)
        return () => {
            document.getElementById('desktopNav').style.display = "flex";
            document.getElementById('mainWrapper').classList.remove('zero-bottom-padding')
        }
    }, [])

    useEffect(() => {
        window.addEventListener('resize', v => {
            setBodyHeight(document.body.clientHeight);
            setBodyWidth(document.body.clientWidth);
        })
        updateView(bodyWidth)

        return () => window.removeEventListener('resize', v => {
            setBodyHeight(document.body.clientHeight);
            setBodyWidth(document.body.clientWidth);
        })
    }, [bodyWidth, bodyHeight])

    return (
        <div className={`lover-wallet-tab ${isDark ? 'lover-tab-dark' : 'lover-tab-light'}`}>
             <div className="lover-tab-mobile">
                <img onClick={goBackSimonHaha} src={require('../../assets/icons/backbutton.svg')} />
                <p>{title}</p>
            </div>
            <div className="lover-tab-row">
                <div onClick={()=>handleClick(0, setIsActive)}>
                    <img src={(isActive === 0) ? require(`../../assets/icons/${img}_a.svg`): require(`../../assets/icons/${img}.svg`)} />
                    <h1>{text}</h1>
                </div>
                <div onClick={()=>handleClick(1, setIsActive)}>
                    <img src={(isActive === 1) ? require(`../../assets/icons/${img2}_a.svg`): require(`../../assets/icons/${img2}.svg`)} />
                    <h1>{text2}</h1>
                </div>
            </div>
        </div>
    )
}
